import { render } from "./Product1.vue?vue&type=template&id=0bdca903&scoped=true"
import script from "./Product1.vue?vue&type=script&lang=js"
export * from "./Product1.vue?vue&type=script&lang=js"

import "./Product1.vue?vue&type=style&index=0&id=0bdca903&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdca903"]])

export default __exports__